import { render, staticRenderFns } from "./sch_jiuye_bzr.vue?vue&type=template&id=20226161&scoped=true"
import script from "./sch_jiuye_bzr.vue?vue&type=script&lang=js"
export * from "./sch_jiuye_bzr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20226161",
  null
  
)

export default component.exports